/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GuidanceProfileResponse,
  GuidanceStateResponse,
  RecordGuidanceEventsDto,
  ResetGuidanceDto,
  UpdateGuidanceProfileDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * تنظیمات راهنمای کاربر، وضعیت خوش‌آمدگویی و هر راهنمای بخش، و ساعت سرور. در حالت ورود به‌جای کاربر هیچ چیزی ذخیره نمی‌شود و readOnly برابر true است.
 * @summary وضعیت راهنماهای من
 */
export const guidanceState = (

 signal?: AbortSignal
) => {


      return apiClient<GuidanceStateResponse>(
      {url: `/api/v1/guidance`, method: 'GET', signal
    },
      );
    }




export const getGuidanceStateQueryKey = () => {
    return [
    `/api/v1/guidance`
    ] as const;
    }


export const getGuidanceStateQueryOptions = <TData = Awaited<ReturnType<typeof guidanceState>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guidanceState>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGuidanceStateQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof guidanceState>>> = ({ signal }) => guidanceState(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof guidanceState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GuidanceStateQueryResult = NonNullable<Awaited<ReturnType<typeof guidanceState>>>
export type GuidanceStateQueryError = void


export function useGuidanceState<TData = Awaited<ReturnType<typeof guidanceState>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof guidanceState>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guidanceState>>,
          TError,
          Awaited<ReturnType<typeof guidanceState>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGuidanceState<TData = Awaited<ReturnType<typeof guidanceState>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guidanceState>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guidanceState>>,
          TError,
          Awaited<ReturnType<typeof guidanceState>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGuidanceState<TData = Awaited<ReturnType<typeof guidanceState>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guidanceState>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary وضعیت راهنماهای من
 */

export function useGuidanceState<TData = Awaited<ReturnType<typeof guidanceState>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guidanceState>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGuidanceStateQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * رویدادهای خوش‌آمدگویی و راهنماها (پیشنهاد، شروع، مرحله، پایان، رد، تعویق) به‌صورت دسته‌ای. از نوع پیشنهاد فقط «نمایش داده شد» پذیرفته می‌شود. رویداد تکراری (همان clientEventId) نادیده گرفته می‌شود.
 * @summary ثبت رویدادهای راهنما
 */
export const guidanceRecord = (
    recordGuidanceEventsDto: RecordGuidanceEventsDto,
 signal?: AbortSignal
) => {


      return apiClient<GuidanceStateResponse>(
      {url: `/api/v1/guidance/events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: recordGuidanceEventsDto, signal
    },
      );
    }




export const getGuidanceRecordMutationKey = () => ['guidanceRecord'] as const;

export const getGuidanceRecordMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof guidanceRecord>>, TError,GuidanceRecordMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof guidanceRecord>>, TError,GuidanceRecordMutationVariables, TContext> => {

const mutationKey = getGuidanceRecordMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof guidanceRecord>>, GuidanceRecordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  guidanceRecord(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GuidanceRecordMutationResult = NonNullable<Awaited<ReturnType<typeof guidanceRecord>>>
    export type GuidanceRecordMutationBody = RecordGuidanceEventsDto
    export type GuidanceRecordMutationError = void
    export type GuidanceRecordMutationVariables = {data: RecordGuidanceEventsDto}

    /**
 * @summary ثبت رویدادهای راهنما
 */
export const useGuidanceRecord = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof guidanceRecord>>, TError,GuidanceRecordMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof guidanceRecord>>,
        TError,
        GuidanceRecordMutationVariables,
        TContext
      > => {
      return useMutation(getGuidanceRecordMutationOptions(options), queryClient);
    }
    /**
 * روشن و خاموش‌کردن پیشنهاد خودکار راهنمای بخش‌ها، نمایش پیشنهادها، توقف موقت آن‌ها و دسته‌هایی که نمی‌خواهید ببینید. در حالت ورود به‌جای کاربر ذخیره نمی‌شود.
 * @summary تنظیمات راهنما و پیشنهادهای من
 */
export const guidanceUpdateProfile = (
    updateGuidanceProfileDto: UpdateGuidanceProfileDto,
 signal?: AbortSignal
) => {


      return apiClient<GuidanceProfileResponse>(
      {url: `/api/v1/guidance/profile`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateGuidanceProfileDto, signal
    },
      );
    }




export const getGuidanceUpdateProfileMutationKey = () => ['guidanceUpdateProfile'] as const;

export const getGuidanceUpdateProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof guidanceUpdateProfile>>, TError,GuidanceUpdateProfileMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof guidanceUpdateProfile>>, TError,GuidanceUpdateProfileMutationVariables, TContext> => {

const mutationKey = getGuidanceUpdateProfileMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof guidanceUpdateProfile>>, GuidanceUpdateProfileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  guidanceUpdateProfile(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GuidanceUpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof guidanceUpdateProfile>>>
    export type GuidanceUpdateProfileMutationBody = UpdateGuidanceProfileDto
    export type GuidanceUpdateProfileMutationError = unknown
    export type GuidanceUpdateProfileMutationVariables = {data: UpdateGuidanceProfileDto}

    /**
 * @summary تنظیمات راهنما و پیشنهادهای من
 */
export const useGuidanceUpdateProfile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof guidanceUpdateProfile>>, TError,GuidanceUpdateProfileMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof guidanceUpdateProfile>>,
        TError,
        GuidanceUpdateProfileMutationVariables,
        TContext
      > => {
      return useMutation(getGuidanceUpdateProfileMutationOptions(options), queryClient);
    }
    /**
 * وضعیت خوش‌آمدگویی و/یا راهنماهای بخش‌های همین کاربر پاک می‌شود تا دوباره مثل روز اول پیشنهاد شوند. هیچ اطلاعاتی از کلینیک تغییر نمی‌کند.
 * @summary از نو نشان دادن راهنماها
 */
export const guidanceReset = (
    resetGuidanceDto: ResetGuidanceDto,
 signal?: AbortSignal
) => {


      return apiClient<GuidanceStateResponse>(
      {url: `/api/v1/guidance/reset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetGuidanceDto, signal
    },
      );
    }




export const getGuidanceResetMutationKey = () => ['guidanceReset'] as const;

export const getGuidanceResetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof guidanceReset>>, TError,GuidanceResetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof guidanceReset>>, TError,GuidanceResetMutationVariables, TContext> => {

const mutationKey = getGuidanceResetMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof guidanceReset>>, GuidanceResetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  guidanceReset(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GuidanceResetMutationResult = NonNullable<Awaited<ReturnType<typeof guidanceReset>>>
    export type GuidanceResetMutationBody = ResetGuidanceDto
    export type GuidanceResetMutationError = unknown
    export type GuidanceResetMutationVariables = {data: ResetGuidanceDto}

    /**
 * @summary از نو نشان دادن راهنماها
 */
export const useGuidanceReset = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof guidanceReset>>, TError,GuidanceResetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof guidanceReset>>,
        TError,
        GuidanceResetMutationVariables,
        TContext
      > => {
      return useMutation(getGuidanceResetMutationOptions(options), queryClient);
    }
